import React from 'react'
import { CTA_FILL } from 'common/tw/ui'
import { PurchaseDetailsVM } from '../lib/planViewModel'
import PurchaseDetails from './PurchaseDetails'

interface PurchasePanelProps {
  // null until the buyer picks a plan and its seat count settles.
  details: PurchaseDetailsVM | null
  // Changes identity when the chosen plan changes, so the table crossfades.
  transitionKey: string
  count: number
  minCount: number
  onCountChange: (n: number) => void
  planName: string
  onCheckout: () => void
  // Kept as a ref target so the page can scroll the panel into view.
  panelRef: React.RefObject<HTMLDivElement>
}

/** The purchase table and checkout button, revealed once a plan is chosen. */
function PurchasePanel({
  details,
  transitionKey,
  count,
  minCount,
  onCountChange,
  planName,
  onCheckout,
  panelRef,
}: PurchasePanelProps) {
  // The panel appears only once a plan is chosen, so there is nothing to collapse when empty.
  if (!details) return null

  return (
    <div ref={panelRef}>
      <div key={transitionKey} className='anim-up mt-7'>
        <PurchaseDetails
          planName={details.planName}
          priceDisplay={details.priceDisplay}
          includedLabel={details.includedLabel}
          includedValue={details.includedValue}
          extraLabel={details.extraLabel}
          extraUnit={details.extraUnit}
          originalPriceDisplay={details.originalPriceDisplay}
          discountLabel={details.discountLabel}
          seatPrice={details.seatPrice}
          originalSeatPrice={details.originalSeatPrice}
          count={count}
          minCount={minCount}
          onCountChange={onCountChange}
          billingLabel={details.billingLabel}
          expiresAt={details.expiresAt}
          total={details.total}
          originalTotal={details.originalTotal}
          perSeat={details.perSeat}
        />
      </div>

      <button type='button' onClick={onCheckout} className={`${CTA_FILL} mt-6`}>
        Get {planName} · ${details.total.toFixed(2)} ›
      </button>
    </div>
  )
}

export default PurchasePanel
